/**
 * 
 * @param str string used to generate the number
 * @returns the exact same "random" rating based on the string passed in argument
 */

const getRandomRatingFromString = (str: string) => {
  let randomStringNumber;

  if (!str) {
    randomStringNumber = (Math.random() * 10).toString();
  } else {
    randomStringNumber = str?.length?.toString()?.[0] || 0;
  }

  return parseInt(randomStringNumber, 10) * 0.1 + 4;
};

export default getRandomRatingFromString;
